import {
  RENTAL_INTRO_STEP,
  RENTAL_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Rental";
import {
  RentalProductIntroFormValues,
  RentalProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Rental/rentalFormValuesInterfaces";

import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export interface RentalProductBackend {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: string;
  monthlyRent: number;
  dateOfBirth: string;
  address: { zipCode: string; city?: string };
}

export const mapToCommerceRental = (
  data: Record<string, any>,
): RentalProductBackend => {
  const introData: RentalProductIntroFormValues =
    data.formData[RENTAL_INTRO_STEP.id];
  const priceData: RentalProductPriceFormValues =
    data.formData[RENTAL_PRICE_STEP.id];
  const user = data.customerData.newCustomerResponse;

  return {
    name: INSURANCE_NAME_VALUE.RENTAL,
    coverageGroup: priceData.coverage,
    monthlyRent: introData.monthlyRent,
    dateOfBirth: user.dateOfBirth,
    address: { zipCode: introData.postNumber, city: introData.city },
  };
};
